import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UnsubscribePage = () => {
  const [params] = useSearchParams();
  const initialEmail = params.get("email") || "";
  const [email, setEmail] = useState(initialEmail);
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("submitting");
    try {
      const res = await axios.post(`${API}/marketing/unsubscribe`, { email });
      setStatus("success");
      setMessage(res.data.message || "You've been unsubscribed.");
    } catch (err) {
      setStatus("error");
      setMessage(err?.response?.data?.detail || "Something went wrong. Please email hello@orderandcleanco.com.au");
    }
  };

  return (
    <div className="bg-white min-h-[70vh]" data-testid="unsubscribe-page">
      <div className="max-w-xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-widest text-slate-500 mb-4">Email Preferences</p>
        <h1
          className="text-4xl sm:text-5xl font-bold text-[#0A0A0A] mb-4"
          style={{ fontFamily: "Barlow Condensed, sans-serif" }}
        >
          Unsubscribe
        </h1>
        <p className="text-slate-600 leading-relaxed mb-8">
          Enter the email address you used to book with Order &amp; Clean Co and we'll stop sending
          you marketing emails (suggestions for space enhancements, follow-ups). You'll still
          receive transactional emails such as booking confirmations and appointment reminders.
        </p>

        {status === "success" ? (
          <div
            className="bg-green-50 border border-green-200 rounded-lg p-6"
            data-testid="unsubscribe-success"
          >
            <p className="text-green-900 font-semibold mb-2">You're unsubscribed.</p>
            <p className="text-green-800 text-sm">{message}</p>
            <Link
              to="/"
              className="inline-block mt-4 text-[#1a365d] font-semibold hover:underline"
            >
              ← Back to home
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <label className="block">
              <span className="text-sm font-semibold text-slate-700">Email address</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 block w-full rounded-md border border-slate-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#1a365d]"
                placeholder="you@example.com"
                data-testid="unsubscribe-email-input"
              />
            </label>
            <button
              type="submit"
              disabled={status === "submitting"}
              className="w-full bg-[#1a365d] text-white font-bold py-3 rounded-md hover:bg-[#0f2545] transition-colors disabled:opacity-60"
              data-testid="unsubscribe-submit"
            >
              {status === "submitting" ? "Unsubscribing..." : "Unsubscribe me"}
            </button>
            {status === "error" && (
              <p className="text-red-600 text-sm" data-testid="unsubscribe-error">
                {message}
              </p>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
